import request from '@/utils/request'

/**
 * 分页查询PLUS会员等级列表
 */
export function pageList(params) {
  return request({
    url: '/plus/level/page',
    method: 'get',
    params: params
  })
}

/**
 * 添加PLUS会员等级
 */
export function add(data) {
  return request({
    url: '/plus/level/add',
    method: 'post',
    data: data
  })
}

/**
 * 删除PLUS会员等级
 */
export function deleteLevel(id) {
  return request({
    url: '/plus/level/delete',
    method: 'post',
    params: { id: id }
  })
}

/**
 * 编辑PLUS会员等级
 */
export function edit(data) {
  return request({
    url: '/plus/level/edit',
    method: 'post',
    data: data
  })
}

/**
 * 查询所有PLUS会员等级列表（不分页）
 */
export function listAll() {
  return request({
    url: '/plus/level/list',
    method: 'get'
  })
}

/**
 * 查询PLUS会员等级详情
 */
export function detail(id) {
  return request({
    url: '/plus/level/detail',
    method: 'get',
    params: { id: id }
  })
}

/**
 * 更新PLUS会员等级状态
 */
export function updateStatus(id, status) {
  return request({
    url: '/plus/level/updateStatus',
    method: 'post',
    params: { id: id, status: status }
  })
}

/**
 * 查询PLUS会员购买记录列表
 */
export function listPlusOrders(params) {
  return request({
    url: '/plus/order/list',
    method: 'get',
    params: params
  })
}

